define("@latermedia/ember-later-analytics/utils/state-types/private-boards", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  /**
   * @module Utils
   */

  /**
   * @class PrivateBoardsUtil
   * @extends Utils
   */

  /**
   * Private Boards State
   *
   * @property PRIVATE_BOARDS
   * @returns {string}
   */
  const PRIVATE_BOARDS = 'privateBoards';
  var _default = _exports.default = PRIVATE_BOARDS;
});